import { useEffect, useMemo, useState } from 'react';
import { InfoFeedClient } from '../helpers/client';

export function useInfoFeedData<T>(fetcher: (client: InfoFeedClient) => Promise<T>): T | undefined {
  const client = useMemo(() => new InfoFeedClient(), []);
  const [data, setData] = useState<T>();

  useEffect(() => {
    fetcher(client)
      .then((response) => {
        setData(response);
      })
      .catch((err) => console.log(err));
  }, [client, fetcher]);

  return data;
}
